import { FormEvent } from 'react';
import { makeStyles } from '@material-ui/core';
import { MDSPopup } from '@marqvision/mds/core';
import { MDSTypography, MDSButton, MDSIcon } from '@marqvision/mds-v2';
import { RootRouteEnum } from '~/router/@types';

const useStyles = makeStyles(() => ({
  guideWrapper: {
    padding: '24px',
  },
  guideTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  buttonWrapper: {
    width: '100%',
    textAlign: 'right',
    padding: '16px 59px',
  },
}));

const ClusterUpdatedDialog = () => {
  const classes = useStyles();

  const handleFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    window.location.href = `/${RootRouteEnum.SellerAnalytics}`;
  };

  return (
    <MDSPopup width="300px" shouldApplyBackdropFilter>
      <form onSubmit={handleFormSubmit}>
        <div className={classes.guideWrapper}>
          <div className={classes.guideTextWrapper}>
            <MDSIcon.Task />
            <MDSTypography variant="body" size="l" weight="medium">
              Cluster has been updated!
            </MDSTypography>
          </div>
        </div>
        <div className={classes.buttonWrapper}>
          <MDSButton type="submit" endIcon={<MDSIcon.ArrowRight variant="outline" />}>
            View updated clusters
          </MDSButton>
        </div>
      </form>
    </MDSPopup>
  );
};

export default ClusterUpdatedDialog;
